const closeButtonLabel = "Sulge";
const etEE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  etEE as default
};
